<template>
  <div class="user">
    <div class="header bg-color-red acea-row row-between-wrapper">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="pictrue"><img :src="userInfo.avatar" /></div>
        <div class="text">
          <div class="acea-row row-middle">
            <div class="name line1">{{ userInfo.nickname }}</div>
            <div class="member acea-row row-middle" v-if="userInfo.vip">
              <img :src="userInfo.vip_icon" />{{ userInfo.vip_name }}
            </div>
          </div>
          <div class="id">
            ID：{{ userInfo.uid || 0 }}
            <!-- <span class="iconfont icon-bianji1"></span> -->
          </div>
          <!-- <router-link :to="'/user/binding'" class="binding" v-else>
            <span>绑定手机号</span>
          </router-link> -->
        </div>
      </div>
      <!-- <span
        class="iconfont icon-shezhi"
        @click="$router.push({ path: '/user/data' })"
      ></span> -->
    </div>
    <div class="wrapper">
      <div class="nav acea-row row-middle">
        <!-- <router-link :to="{ path: '/user/account' }" class="item">
          <div>累计消费</div>
          <div class="num">{{ userInfo.orderStatusSum || 0 }}</div>
        </router-link> -->
        <!--<router-link-->
        <!--:to="'/user/user_promotion'"-->
        <!--class="item"-->
        <!--v-if="userInfo.is_promoter === 1 || userInfo.statu === 2"-->
        <!--&gt;-->
        <!--</router-link>-->
        <!-- <router-link :to="'/user/integral'" class="item" v-else>
          <div>当前积分</div>
          <div class="num">{{ userInfo.integral || 0 }}</div>
        </router-link> -->
        <div @click="goPagey('/user/promoter_list')" class="item">
          <div>团队人数</div>
          <div class="num">{{ first + second }}</div>
        </div>
        <div
          @click="goPagey('/user/user_promotion')"
          class="item"
          v-if="userInfo.is_promoter === 1 || userInfo.statu === 2"
        >
          <div>当前佣金</div>
          <div class="num">{{ userInfo.brokerage_price || 0 }}</div>
        </div>
        <router-link :to="'/user/user_coupon'" class="item">
          <div>优惠券</div>
          <div class="num">{{ userInfo.couponCount || 0 }}</div>
        </router-link>
        <router-link :to="'/user/integral'" class="item">
          <div>积分</div>
          <div class="num">{{ userInfo.integral || 0 }}</div>
        </router-link>
      </div>
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>我的订单</div>
          <router-link :to="'/order/list/'" class="allOrder">
            全部订单<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link :to="{ path: '/order/list/' + 0 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfk.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unpaid_count > 0"
                >{{ orderStatusNum.unpaid_count }}</span
              >
            </div>
            <div>待付款</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 1 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unshipped_count > 0"
                >{{ orderStatusNum.unshipped_count }}</span
              >
            </div>
            <div>待发货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 2 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dsh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.received_count > 0"
                >{{ orderStatusNum.received_count }}</span
              >
            </div>
            <div>待收货</div>
          </router-link>
          <!-- <router-link :to="{ path: '/order/list/' + 3 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dpj.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.evaluated_count > 0"
                >{{ orderStatusNum.evaluated_count }}</span
              >
            </div>
            <div>待评价</div>
          </router-link> -->
          <router-link :to="'/order/refund_list'" class="item">
            <div class="pictrue">
              <img src="@assets/images/sh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.refund_count > 0"
                >{{ orderStatusNum.refund_count }}</span
              >
            </div>
            <div>售后/退款</div>
          </router-link>
        </div>
      </div>
      <div class="myService">
        <div class="title acea-row row-middle">我的服务</div>
        <div class="serviceList acea-row row-middle">
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="item.wap_url"
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
          <div 
            class="item"
            v-for="(item,index) in csList"
            :key="index"
            @click="openCsPopup(item)"
            >
            <div class="pictrue">
              <img :src="item.icon">
            </div>
            <div>{{item.name}}</div>
          </div>
          <!-- <div
            class="item"
            @click="goPages(10)"
          >
            <div class="pictrue">
              <img src="../../assets/images/icon_activity.png" />
            </div>
            <div>抽奖</div>
          </div> -->
        </div>
      </div>
    </div>
    <img src="@assets/images/support.png" class="support" />
    <div class="footer-line-height"></div>
    <SwitchWindow
      v-on:changeswitch="changeswitch"
      :switchActive="switchActive"
      :login_type="userInfo.login_type"
    ></SwitchWindow>
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
    <CustomeServicePopup
      :isPopupShow="isPopupShow"
      :csPopupMsg="csPopupMsg"
      @closePrePopup="closePrePopup"
    ></CustomeServicePopup>
    
  </div>
</template>

<script>
import { getSpreadUser, getUser, getMenuUser ,getCsQrcode} from "@api/user";
import { isWeixin } from "@utils";
import SwitchWindow from "@components/SwitchWindow";
import GeneralWindow from "@components/GeneralWindow";
import CustomeServicePopup from "@components/CustomeServicePopup";
// import AfterServicePopup from "@components/AfterServicePopup";
const NAME = "User";

export default {
  name: NAME,
  components: {
    SwitchWindow,
    GeneralWindow,
    CustomeServicePopup,
    // AfterServicePopup
  },
  props: {},
  data: function() {
    return {
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      },
      screen: {
        page: 1,
        limit: 10000,
        grade: 0,
        keyword: "",
        sort: "",
        agent: 0
      },
      first: "",
      second: "",
      //客服弹窗
      precustomerPopupActive:false,
      csList:[],
      isPopupShow:false,
      csPopupMsg:{}
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    }
  },
  mounted: function() {
    this.User();
    this.MenuUser();
    this.isWeixin = isWeixin();
    this.getPromoter();
    this.getCsQrcode();
  },
  methods: {
    getPromoter: function () {
      let that = this;
      getSpreadUser(screen).then(
        res => {
          that.first = res.data.total;
          that.second = res.data.totalLevel;
        },
        error => {
          that.$dialog.message(error.msg);
        },
        300
      );
    },
    changeswitch: function(data) {
      this.switchActive = data;
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        console.log(res)
        that.userInfo = res.data;
        that.orderStatusNum = res.data.orderStatusNum;
        if(res.data.promoter_price <= 0){
          this.generalContent = {
          promoterNum: `请您耐心等待审核`,
          title: "您未获得推广权限"
          };
        }else{
          this.generalContent = {
          promoterNum: `您在商城累计消费金额仅差 <span style="color: #d2ac72;">${res
            .data.promoter_price || 0}元</span>即可开通推广权限`,
          title: "您未获得推广权限"
          };
        }
        
      });
    },
    MenuUser: function() {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus.filter(item=>{
          return !['直播'].includes(item.name)
        });
      });
    },
    goPagey(url) {
      if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
        return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
        return (this.generalActive = true);
      }
      this.$router.push({ path: url });
    },
    goPages: function(index) {
      if(index == 10) return this.$router.push({path: '/activity/lottery'})
      if(index == 11) return this.$router.push({path: '/user/user_coupon'})
      let url = this.MyMenus[index].wap_url;
      if (url === "/user/user_promotion") {
        if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
          return this.$dialog.toast({ mes: "您还没有推广权限！！" });
        if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
          return (this.generalActive = true);
        }
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "您还不是客服！！" });
      }
      this.$router.push({ path: this.MyMenus[index].wap_url });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
    },

    // 客服弹窗
    PrePopupActive(){
      this.precustomerPopupActive = true;
    },
    closePrePopup(Boolean){
      this.isPopupShow = Boolean;
    },
    closeAfterPopup(Boolean){
      this.aftercustomerPopupActive = Boolean;
    },
    getCsQrcode(){
      getCsQrcode().then(res => {
        this.csList = res.data;
      })
    },
    openCsPopup(item){
      this.isPopupShow = true;
      this.csPopupMsg = item;
    }
  }
};
</script>

<style scoped>
.item{
  width: 25%;
}
.footer-line-height {
  height: 1rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #c9975c;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #c9975c;
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background: linear-gradient(90deg, #e9d2a9, #d2ac72);
  background: -webkit-linear-gradient(90deg, #e9d2a9, #d2ac72);
  background: -moz-linear-gradient(90deg, #e9d2a9, #d2ac72);
  background: -ms-linear-gradient(90deg, #e9d2a9, #d2ac72);
  border-radius: 50px;
  font-size: 0.14rem;
  color: #471d1d;
}
.num{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    align-content: center;
}
</style>
